import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const ContactUs = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    productName: '',
    productSize: '',
    name: '',
    phone: '',
    email: '',
    address: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_tmd6bbq', // replace with your EmailJS service ID
      'template_lssj9l9', // replace with your EmailJS template ID
      formRef.current,
      'uVR4cDVf23DdRJzRy' // replace with your EmailJS public key
    ).then(
      (result) => {
        console.log(result.text);
        setStatus('Message sent successfully!');
        setFormData({
          productName: '',
          productSize: '',
          name: '',
          phone: '',
          email: '',
          address: '',
          message: ''
        });
      },
      (error) => {
        console.log(error.text);
        setStatus('Failed to send message. Please try again.');
      }
    );
  };

  return (
    <section id='contact' className="contact-section">
      <div className="contact-container">
        {/* Left Side */}
        <div className="contact-info">
          <h2 className="contact-heading">
            Get In Touch With Us <span className="highlight">Now!</span>
          </h2>
        <div className="info-grid"> <div className="info-item"> <div className="info-icon"> <i className="fas fa-phone-alt"></i> </div> <div className="info-content"> <h3>Phone Number</h3> <p>+91 9267952538 ,+91 8447910939 </p> </div> </div> <div className="info-item"> <div className="info-icon"> <i className="fas fa-envelope"></i> </div> <div className="info-content"> <h3>Email Address</h3> <p>care@newliferesearch.in</p> </div> </div> {/* <div className="info-item"> <div className="info-icon"> <i className="fas fa-map-marker-alt"></i> </div> <div className="info-content"> <h3>Our Location</h3> <p>Wasme House, Plot No. 4</p> <p>Noida Sec. 16A, India</p> </div> </div> */} <div className="info-item"> <div className="info-icon"> <i className="fas fa-clock"></i> </div> <div className="info-content"> <h3>Working Hours</h3> <p>Monday – Friday: 9:30 AM – 6:30 PM</p> </div> </div> </div> <div className="science-elements"> <div className="molecule"></div> <div className="leaf"></div> <div className="atom"></div> </div> </div>     {/* Right Side */}
        <div className="form-header">
          <h2>Contact Us</h2>
          <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Product Name</label>
                <select name="productName" value={formData.productName} onChange={handleChange} required>
                  <option value="">Select Product</option>
                  <option value="Toilet cleaner">Toilet cleaner</option>
                  <option value="Glass cleaner">Glass cleaner</option>
                  <option value="Floor cleaner">Floor cleaner</option>
                  <option value="Dishwash cleaner">Dishwash cleaner</option>
                  <option value="Handwash cleaner">Handwash cleaner</option>
                  <option value="Jasmine air freshener">Jasmine air freshener</option>
                  <option value="Sandalwood air freshener">Sandalwood air freshener</option>
                  <option value="Rose air freshener">Rose air freshener</option>
                </select>
              </div>
              <div className="form-group">
                <label>Product Size</label>
                <select name="productSize" value={formData.productSize} onChange={handleChange} required>
                  <option value="">Select Size</option>
                  {["Jasmine air freshener", "Sandalwood air freshener", "Rose air freshener"].includes(formData.productName) ? (
                    <option value="200ml">200ml</option>
                  ) : (
                    <>
                      <option value="5L">5L</option>
                      <option value="2L">2L</option>
                      <option value="1L">1L</option>
                    </>
                  )}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Address</label>
                <input type="text" name="address" value={formData.address} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Optional message" />
            </div>

            <button type="submit" className="submit-btn">Send Message</button>
            {status && <p className="status-message">{status}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
